import { useFluent } from "@fluentui/react-components";

export function useDir() {
  const { dir } = useFluent();
  const isRTL = () => {
    return dir === "rtl";
  };
  const isLTR = () => {
    return dir === "ltr";
  };
  return {
    dir,
    isRTL,
    isLTR,
  };
}
